import { generatePath, useParams } from '@fs/zion-router'
import { type PID } from '@fs/zion-tree-types'
import { useRouteMatch, type match } from 'react-router'
import { pidRegexStr } from '@fs/zion-pid'
import { type PathParamMap } from '../../utils/pathParamTypes'

export const MERGE_ROUTE_PATH =
  `/merge/:mergeStep(verify|compose|confirm)/:survivorPid(${pidRegexStr as PID})/:duplicatePid(${pidRegexStr as PID})` as const

type MergeRouteParams = PathParamMap<typeof MERGE_ROUTE_PATH>

export type MergeRouteMatch = match<MergeRouteParams>

export const useMergeRouteMatch = (): MergeRouteMatch => useRouteMatch()

export const useMergeParams = (): MergeRouteParams => useParams<MergeRouteParams>()

export const getMergeUrl = (routeMatch: MergeRouteMatch, params: Partial<MergeRouteParams>): string =>
  generatePath(routeMatch.path, { ...routeMatch.params, ...params })
